// Clicking the logo opens the file picker; choosing a file submits the upload immediately, so there
// is no separate "save" step. Handlers are delegated because the component loads into its Turbo
// Frame after document ready.
$(document).on('click', '.brand-groups-administration-component .brand-group-logo', function () {
  $(this).closest('.brand-group-logo-form').find('.brand-group-logo-input').trigger('click');
});

$(document).on('change', '.brand-groups-administration-component .brand-group-logo-input', function () {
  if (!this.files || !this.files.length) return;

  this.form.submit();
});
